import { reactive, inject, InjectionKey, provide } from '@vue/composition-api'

export type ClientId = string | null

export interface ClientIdState {
  clientId: ClientId
}

export const ClientIdStateKey: InjectionKey<ClientIdState> = Symbol(
  'clientIdState'
)
export const clientIdState = () =>
  reactive({
    clientId: null
  })

export const useClientIdState = () => inject(ClientIdStateKey)
export const provideClientIdState = () =>
  provide(ClientIdStateKey, clientIdState())
